import {
  NegativeColors,
  PositiveColors,
  PrimaryColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      backgroundColor: (props: { dark?: boolean }) =>
        props.dark ? NegativeColors.base.default : PositiveColors.base.default,
    },
    banner: {
      display: 'grid',
      gridTemplateRows: '1fr',
      gridTemplateColumns: '6fr 6fr',
      gridTemplateAreas: "'media content'",
      gridGap: Spacings.s72,

      '&.reversed': {
        gridTemplateAreas: "'content media'",

        // [mediaQuery(766)]: {
        '@media screen and (max-width: 766px)': {
          gridTemplateColumns: '1fr',
          gridTemplateAreas: "'media' 'content'",
          gridGap: Spacings.s0,
          margin: [Spacings.s0, 'auto'],
          maxWidth: 456,
        },
      },

      [mediaQuery(1365)]: {
        gridGap: 82,
      },

      [mediaQuery(1023)]: {
        gridGap: 52,
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        gridTemplateColumns: '1fr',
        gridTemplateAreas: "'media' 'content'",
        gridGap: Spacings.s0,
        margin: [Spacings.s0, 'auto'],
        maxWidth: 456,
      },
    },

    contentWrapper: {
      gridArea: 'content',
      color: props => (props.dark ? NegativeColors.text.default : TextColors.base),
      '& a': {
        color: PrimaryColors.base.default,
      },
    },

    mediaWrapper: {
      gridArea: 'media',
    },
  }),
  {
    name: 'body-text-marketing',
  },
);

export default useStyles;
